import { v5 as uuidv5 } from 'uuid';

const ARBITRARY_UUID = '1c01757f-50e3-4f74-babc-567ae1269197';

export const getRealtimeDocId = (documentPath: string) => {
  return uuidv5(documentPath, ARBITRARY_UUID);
};
